import {
  getUserDataApi,
  registerApi,
  updateProfileApi,
  verifyMobileNumberApi,
  resendOtpApi,
  verifyOtpApi,
  userFeedbackApi,
  getLanguagesApi,
  messageLanguageApi,
  loginApi
} from "../ENV";
import { fetchApi } from "./FetchAPI";
import { getDefaultLanguage } from "./Utils";

export async function verifyMobileNumber(mobileNumber) {
  var headerValue = {
    Accept: "application/json",
    "Content-type": "application/json"
  };
  var params = {
    mobile_number: mobileNumber,
    language: getDefaultLanguage()
  }
  const res = await fetchApi(verifyMobileNumberApi, "GET", {}, headerValue, params);
  
  return res;
}

export async function resendOtp(mobileNumber) {
  var headerValue = {
    Accept: "application/json",
    "Content-type": "application/json"
  };

  const res = await fetchApi(resendOtpApi, "POST", JSON.stringify({"mobile_number": mobileNumber}), headerValue, {});
  return res;
}


export async function verifyOtp(mobileNumber, idToken, deviceData, browserData, langCode) {
  const payloadJSON = {
    mobile_number: `+91${mobileNumber}`,
    id_token: idToken,
    device_data: deviceData,
    browser_data: browserData,
    language: langCode
  };

  const headerValue = {
    Accept: "application/json",
    "Content-type": "application/json",
  };

  const res = await fetchApi(
    verifyOtpApi,
    "POST",
    JSON.stringify(payloadJSON),
    headerValue,
    {}
  );
  return res;
}
export async function iframeLogin(idToken, deviceData, browserData, langCode, cadre, kb, approach ) {

  const payloadJSON = {
    language: langCode,
    cadre: cadre,
    kb: kb,
    approach: approach,
    device_data: deviceData,
    browser_data: browserData,
  };

  const headerValue = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${idToken}`
  };

  const res = await fetchApi(
    loginApi,
    "POST",
    JSON.stringify(payloadJSON),
    headerValue,
    {}
  );
  return res;
}

export async function register(mobileNumber, formData) {
  let formDataObj = {...formData}
  formDataObj.mobile = mobileNumber
  var payloadJSON = {
    formData: formDataObj
  };
  var headerValue = {
    Accept: "application/json",
    "Content-type": "application/json",
  };

  const res = await fetchApi(
    registerApi,
    "POST",
    JSON.stringify(payloadJSON),
    headerValue,
    {}
  );
  return res;
}

export async function resetPassword(access_token, oldPassword, newPassword) {
  var payloadJSON = {
    old_password: oldPassword,
    new_password: newPassword,
  };
  var headerValue = {
    Accept: "application/json",
    "Content-type": "application/json",
    "x-access-token": access_token
  };

  const res = await fetchApi(
    updateProfileApi,
    "POST",
    JSON.stringify(payloadJSON),
    headerValue,
    {}
  );
  return res;
}

export async function updateProfile(access_token, updateObj) {
  var payloadJSON = updateObj;
  var headerValue = {
    Accept: "application/json",
    "Content-type": "application/json",
    "x-access-token": access_token
  };

  const res = await fetchApi(
    updateProfileApi,
    "POST",
    JSON.stringify(payloadJSON),
    headerValue,
    {}
  );
  return res;
}

export async function getUserData(access_token) {
  var headerValue = {
    "x-access-token": access_token,
  };
  const res = await fetchApi(getUserDataApi, "GET", {}, headerValue, {});
  return res.Response;
}


export async function sendUserFeedback(access_token, feedback, media=null) {
  var payloadJSON = {
    "feedback": {
      "message": feedback,
      "media": media
    }
  };
  var headerValue = {
    Accept: "application/json",
    "Content-type": "application/json",
    "x-access-token": access_token
  };

  const res = await fetchApi(
    userFeedbackApi,
    "POST",
    JSON.stringify(payloadJSON),
    headerValue,
    {}
  );
  return res;
}

export async function getLanguages(cadre = null, kb = null) {
  var headerValue = {
    Accept: "application/json",
    "Content-type": "application/json"
  };

  let params = {};
  if (cadre) params.cadre = cadre;
  if (kb) params.kb = kb;

  const res = await fetchApi(getLanguagesApi, "GET", {}, headerValue, params);
  return res;
}

export async function setMessageLanguage(access_token, language, cadre, kb) {
  const payloadJSON = {
    language: language,
    welcome: true,
    cadre: cadre,
    kb: kb
  };
  const headerValue = {
    "Content-Type": "application/json",
    "x-access-token": access_token
  };
  const res = await fetchApi(
    messageLanguageApi,
    "PUT",
    JSON.stringify(payloadJSON),
    headerValue,
    {}
  );
  return res;
}

